module.exports = __webpack_public_path__ + "img/CF_grey.756811da.svg";